import { all, call, put, takeLatest, select } from "redux-saga/effects";
import * as jsonpatch from "fast-json-patch";
import cloneDeep from "lodash.clonedeep";
import httpClient from "./http-client";
import { createTaskFailure,
  createTaskRequested,
  createTaskSuccess,
  CREATE_TASK,
  UPDATE_TASK,
  fetchTasksFailure,
  fetchTasksRequested,
  fetchTasksSuccess,
  FETCH_TASKS,
  FETCH_TASK_BY_ID,
  fetchTaskByIdFailure,
  fetchTaskByIdSuccess,
  fetchTaskByIdRequested,
  fetchTaskById,
  updateTaskFailure,
  updateTaskSuccess,
  updateTaskRequested,
  fetchTasks } from "../actions/tasks-action-types";
import { createQuote } from "../actions/quote-action-types";
import { fetchConsumerChartsData } from "../actions/analytics-action-types";

export function* addTaskHandler({ payload }) {
  yield put(createTaskRequested());
  const userData = yield select((state) => state?.user?.user);
  const userId = userData?.identifier;
  const request = {
    data: {
      payload: {
        userId,
        description: payload.description.trim(),
        name: payload.name.trim(),
        coverImage: payload.coverImage,
        dueDate: payload.dueDate.getTime(),
        category: payload.category,
        status: payload.status,
        createdAt: Date.now(),
        updatedAt: Date.now(),
        isService: payload?.isService,
        isDeleted: false,
      },
    },
    method: "POST",
    url: "/api/v1/tasks",
  };
  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(createTaskFailure(error));
  } else {
    const taskId = data.details.id;

    if (payload?.isCreateQuote) {
      yield put(createQuote({
        ...payload?.quoteData,
        taskId,
        userId,
        itemDetails: {
          description: payload.description.trim(),
          name: payload.name.trim(),
          coverImage: payload.coverImage,
          dueDate: payload.dueDate.getTime(),
          category: payload.category,
          status: payload.status,
        },
      }));
    }
    yield put(fetchTaskById(taskId));
    yield put(createTaskSuccess(data));
    yield put(fetchConsumerChartsData());
  }
}

export function* updateTaskHandler({ payload }) {
  yield put(updateTaskRequested());

  const tasks = yield select((state) => state?.tasks?.tasks);
  const updatedTasks = cloneDeep(tasks);

  const singleTask = updatedTasks.find((task) => task.identifier === payload.identifier);
  const updates = {
    ...singleTask,
    ...payload,
  };

  const diffPayload = jsonpatch.compare(singleTask, updates);

  if (diffPayload.length) {
    const request = {
      data: { payload: diffPayload },
      method: "PATCH",
      url: `/api/v1/tasks/${payload.identifier}`,
    };

    const {
      data, error,
    } = yield call(httpClient, request, true);

    if (error) {
      yield put(updateTaskFailure(error));
    } else {
      yield put(fetchTasks());
      yield put(updateTaskSuccess(data));
      yield put(fetchConsumerChartsData());
    }
  }
}

export function* fetchAllTasksHandler() {
  yield put(fetchTasksRequested());

  const userData = yield select((state) => state?.user?.user);
  const userId = userData?.identifier;
  const request = {
    method: "GET",
    params: {
      userId, sort: "asc",
    },
    url: "/api/v1/tasks",
  };

  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(fetchTasksFailure(error));
  } else {
    yield put(fetchTasksSuccess(data.details.response));
    yield put(fetchConsumerChartsData());
  }
}

export function* fetchTaskByIdHandler({ payload }) {
  yield put(fetchTaskByIdRequested());

  const request = {
    method: "GET",
    url: `/api/v1/tasks/${payload}`,
  };

  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(fetchTaskByIdFailure(error));
  } else {
    yield put(fetchTaskByIdSuccess(data.details));
    yield put(fetchConsumerChartsData());
  }
}

function* Task() {
  yield all([
    takeLatest(CREATE_TASK, addTaskHandler),
    takeLatest(UPDATE_TASK, updateTaskHandler),
    takeLatest(FETCH_TASKS, fetchAllTasksHandler),
    takeLatest(FETCH_TASK_BY_ID, fetchTaskByIdHandler),
  ]);
}

export default Task;
